export const initialState = {
  isFetched: false,
  isOrderInfoVisible: false,
  hasEmptyProductsForNextMonth: true,
  isProductsFetching: false,
  orders: [],
  products: [],
}

export const setShipment = (state, payload) => (
  { ...state, ...payload, isFetched: true }
)

export const setFetched = (state) => (
  { ...state, isFetched: true }
)

export const setProductsFetching = (state, payload) => (
  { ...state, isProductsFetching: payload }
)

export const setProducts = (state, payload) => (
  { ...state, products: payload, isProductsFetching: false }
)
